module.exports = __webpack_public_path__ + "img/img-05.99a9eb50.jpg";